// extracted by mini-css-extract-plugin
export default {"label":"mantineCheckbox_label__6MXyq"};